module.exports = require("@swa-ui/core/src/Caption/Caption.module.scss");